import { AdminKeySpace } from '../model/adminKeySpace';
export class AdminKeySpaceBuilder {
    static buildKeySpace(data) {
        const keySpace = new AdminKeySpace();
        keySpace.id = data.id;
        keySpace.id_key_zone = data.id_key_zone;
        keySpace.block = data.block;
        keySpace.col = data.col;
        keySpace.row = data.row;
        keySpace.priority = data.priority;
        keySpace.active = data.active;
        keySpace.id_reservation = data.id_reservation;
        keySpace.out_date = data.out_date;
        keySpace.plate = data.plate;
        keySpace.space_number = data.space_number;
        keySpace.long_time_priority = data.long_time_priority;
        return keySpace;
    }
}
//# sourceMappingURL=adminKeySpace-builder.js.map